<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired, isSubOption: isSubOption}">
    <span class="idStkr">
      {{isSubOption ? `${isSubOption.parentLabel}:${isSubOption.parentValue} > ` : ''}}{{itemSetting.action.labelValue}}
    </span>
    <div class="label" :style="labelStyle">
      {{itemSetting.action.label[activeLang]}}
      <div v-if="conditionMessage"><span class="conditionMessage">{{conditionMessage}}</span></div>
    </div>
    <div class="listItem checkbox"
      v-for="(option, index) in itemSetting.action.item"
      :key="index"
      :class="{quantityOption: hasQuantity}"
      :style="valueStyle">
      <input type="checkbox"
        :name="`checkbox_${id}_${moduleIndex}`"
        :id="`checkbox_${id}_${moduleIndex}_${index}`"
        :value="option.id || `${index}_${option.value}`"
        v-model="itemSetting.action.defaultValue"
        :disabled="itemSetting.action.hasDefault !== true">
      <label :for="`checkbox_${id}_${moduleIndex}_${index}`">
        {{option.label[activeLang]}}
        <span class="optionPrice">
          {{optionPrice(option.price)}}
        </span>
      </label>
      <div v-if="hasQuantity" class="quantity">
        <button type="button" class="btnQuantity" data-quantity="minus" disabled>-</button>
        <input type="text"
          class="inputQuantity"
          :placeholder="`${itemSetting.action.min} ~ ${itemSetting.action.max}`"
          :value="option.quantity"
          disabled>
        <button type="button" class="btnQuantity" data-quantity="plus" disabled>+</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
export default {
  name: 'CheckboxModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting',
    'subOption'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['setting/getCurrencyCode'].toUpperCase()
    },
    hasQuantity () {
      return this.itemSetting.action.optionQuantity
    },
    conditionMessage () {
      const gtVal = this.itemSetting.action.conditionGtVal
      const ltVal = this.itemSetting.action.conditionLtVal
      const specificVal = this.itemSetting.action.conditionSpecificVal
      const hasGt = this.itemSetting.action.conditionGt && gtVal
      const hasLt = this.itemSetting.action.conditionLt && ltVal
      const hasSpecific = this.itemSetting.action.conditionSpecific && specificVal
      let message = ''
      if (this.itemSetting.action.optionCondition) {
        if (hasGt && !hasLt) {
          message = `${gtVal} ${this.locale.option_condition_gt}`
        } else if (hasLt && !hasGt) {
          message = `${ltVal} ${this.locale.option_condition_lt}`
        } else if (hasGt && hasLt) {
          message = `${gtVal} ~ ${ltVal} ${this.locale.option_condition_range}`
        } else if (hasSpecific) {
          message = `${specificVal} ${this.locale.option_condition_specific}`
        }
      }
      return message
    },
    isSubOption () {
      const id = this.id
      return this.subOption.find(x => x.child === id)
    }
  },
  methods: {
    optionPrice (price) {
      const code = this.currency
      return price ? regExp.priceFormat(price, code) : ''
    }
  }
}
</script>
